import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import WhatsAppIcon from '@/components/icons/WhatsAppIcon'
import { WHATSAPP_URL } from '@/data/contact'
import { PREMIERE_VISITE_QUESTIONS } from '@/data/premiereVisite'

export default function PremiereVisiteSection() {
  return (
    <section id="premiere-visite" className="py-16 md:py-20 px-4 bg-cmp-cream">
      <div className="max-w-lg md:max-w-4xl mx-auto">
        <div className="bg-linear-to-br from-cmp-navy to-cmp-navy-dark rounded-3xl rounded-tl-[40px] p-7 md:p-10 text-white shadow-[0_16px_40px_rgba(15,31,92,0.18)] md:grid md:grid-cols-2 md:gap-10">
          <div>
            <span className="text-cmp-gold-light text-xs font-bold uppercase tracking-widest">
              Pour les nouveaux
            </span>
            <h2 className="text-2xl md:text-3xl font-bold leading-snug mt-3 mb-3">
              C'est votre première fois ?
            </h2>
            <p className="text-white/75 text-sm leading-relaxed">
              Comment s'habiller, à quelle heure arriver, où garer sa voiture, ce qui se passe pendant le culte. on répond franchement à tout.
            </p>

            <div className="mt-6 space-y-2.5">
              {PREMIERE_VISITE_QUESTIONS.map((q) => (
                <div key={q} className="flex items-center gap-2.5 text-sm text-white/70">
                  <ChevronRight size={14} className="text-cmp-gold-light shrink-0" />
                  {q}
                </div>
              ))}
            </div>
          </div>

          <div className="mt-7 md:mt-0 flex flex-col justify-center gap-3">
            <Link
              to="/premiere-visite"
              className="flex items-center justify-between bg-white text-cmp-navy font-bold rounded-2xl px-5 py-4 shadow-lg hover:bg-cmp-sky-light transition-colors active:scale-95"
            >
              <span className="text-sm">Tout ce qu'il faut savoir avant de venir</span>
              <ChevronRight size={18} />
            </Link>

            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 border border-white/25 text-white text-sm font-medium rounded-2xl px-5 py-3 hover:bg-white/10 transition-colors"
            >
              <WhatsAppIcon size={16} />
              Prévenez-nous de votre venue
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
